const removeSymbols = document.querySelector('.search-close');
let buttonMembers = document.querySelectorAll('.presenters__nav-link button');
let listMembers = document.querySelectorAll('.presenters__row');
let buttonAllMembers = document.querySelector('.presenters__nav-link-all button');
let searchMembers = document.querySelector('#collection__presenters').innerHTML;
const JsonObject = JSON.parse(searchMembers);

buttonAllMembers.addEventListener('click', () => {
    for (let member of buttonMembers) {
        member.classList.remove('active');
    }
    for (let list of listMembers) {
        list.classList.remove('none');
        list.classList.remove('active');
    }
    buttonAllMembers.classList.add('active');
});

buttonMembers.forEach((buttonMember, index) => {
    buttonMember.addEventListener('click', (e) => {
        let buttonLetter = buttonMember.dataset.letter;
        let memberLetter = listMembers[index].dataset.member;

        for (let member of buttonMembers) {
            member.classList.remove('active');
        }

        for (let list of listMembers) {
            list.classList.remove('active');
            list.classList.add('none');
            if (buttonLetter === memberLetter) {
                buttonAllMembers.classList.remove('active');
                listMembers[index].classList.remove('none');
                listMembers[index].classList.add('active');
                buttonMember.classList.add('active');
            }
        }
    });
});

function searchNames() {
    let searchInput = document.getElementById('member__search');
    let results = document.querySelector('.presenters__search--predictive')
    let searchTerm = searchInput.value.toLowerCase();
    results.innerHTML = '';


    if (searchTerm.length === 0) {
        removeSymbols.classList.remove('active');
        return;
    }

    let matchingNames = JsonObject.members.filter(function (item) {
        let name = item.name.toLowerCase();
        return name.includes(searchTerm);
    });

    matchingNames.forEach(function (item) {
        let div = document.createElement('div');
        div.innerHTML = `<a href="${item.url}"><img src="${item.image}" alt="${item.name}">${item.name}</a>`;
        results.appendChild(div);
        removeSymbols.classList.add('active');
    });
}

removeSymbols.addEventListener('click', () => {
    let searchInput = document.getElementById('member__search');
    let results = document.querySelector('.presenters__search--predictive');
    searchInput.value = "";
    removeSymbols.classList.remove('active');
    results.innerHTML = '';
});

let arrowsLeft = document.querySelectorAll('.arrows-left');
let arrowsRight = document.querySelectorAll('.arrows-right');
arrowsRight.forEach((arrowRight, index) => {
    arrowRight.addEventListener('click', () => {
        let members = arrowRight.parentElement.parentElement.nextElementSibling;
        let member = arrowRight.parentElement.parentElement.nextElementSibling.querySelectorAll('.presenters__links .presenters__inner');
        let length = member.length - 1;
        let activeSlide = Array.from(member).find(element => element.classList.contains('active'));
        member.forEach((element) => element.classList.remove('active'));
        let i = +activeSlide.dataset.slide;
        if (i + 1 === length) {
            arrowRight.classList.add('none');
            members.scrollTo({left: member[length].offsetLeft});
            member[length].classList.add('active');
        } else {
            member[i + 1].classList.add('active');
            members.scrollTo({left: member[i + 1].offsetLeft});
            arrowRight.previousElementSibling.classList.remove('none');
        }
    });
});

arrowsLeft.forEach((arrowLeft, index) => {
    arrowLeft.addEventListener('click', () => {
        let members = arrowLeft.parentElement.parentElement.nextElementSibling;
        let member = arrowLeft.parentElement.parentElement.nextElementSibling.querySelectorAll('.presenters__links .presenters__inner');
        let activeSlide = Array.from(member).find(element => element.classList.contains('active'));
        member.forEach((element) => element.classList.remove('active'));
        let i = +activeSlide.dataset.slide;
        if (i - 1 === 0) {
            arrowLeft.nextElementSibling.classList.remove('none');
            arrowLeft.classList.add('none');
            member[0].classList.add('active');
            members.scrollTo({left: member[0].offsetLeft});
        } else {
            member[i - 1].classList.add('active');
            members.scrollTo({left: member[i - 1].offsetLeft});
            arrowLeft.nextElementSibling.classList.remove('none');
        }
    });
});